import React, { useEffect, useState } from 'react';
import { getListFaqs } from '@src/apis/faq';
import { checkVietNam } from '@src/utils/checkCountry';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '@src/services/package';
import questionImg from '@src/assets/images/question-image.svg';
import Typography from '@src/new-components/Typography';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AccordionDetails } from '@mui/material';
import { PACKAGE_LEVEL_V3, PACKAGE_TYPE } from '@src/constants/package';
import { StyledAccordion, StyledFAQ } from './index.style';

const FAQ = ({ numberOfElements, packages }) => {
  const isVietNam = checkVietNam();
  const platform = 'WEB';
  const category = 'PRICING';
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const [faqs, setFaqs] = useState([]);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    const fetchFaqs = async () => {
      const response = await getListFaqs(category, platform);
      setFaqs(response.result?.faqs || []);
    };
    fetchFaqs();
  }, []);

  const handleChange = (panel) => (_, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  const topupPackageStandard = packages.find(
    (pkg) =>
      pkg.type === PACKAGE_TYPE.STUDIO &&
      pkg.level === PACKAGE_LEVEL_V3.STANDARD &&
      pkg.isTopUp,
  );

  const topupPackageSpecial = packages.find(
    (pkg) =>
      pkg.type === PACKAGE_TYPE.STUDIO &&
      pkg.level === PACKAGE_LEVEL_V3.SPECIAL &&
      pkg.isTopUp,
  );

  const priceStandard = formatPrice({
    vndPrice: isVietNam ? topupPackageStandard?.vndPricePerUnit : 0,
    usdPrice: !isVietNam ? topupPackageStandard?.usdPricePerUnit : 0,
    isVietNam,
    language,
  });

  const priceSpecial = formatPrice({
    vndPrice: isVietNam ? topupPackageSpecial?.vndPricePerUnit : 0,
    usdPrice: !isVietNam ? topupPackageSpecial?.usdPricePerUnit : 0,
    isVietNam,
    language,
  });

  return (
    <StyledFAQ numberOfElements={numberOfElements}>
      <Typography
        style={{
          textAlign: 'center',
          marginBottom: '40px',
          display: 'flex',
          justifyContent: 'center',
        }}
        variant="heading-32-bold"
        color="#1C1C1E"
        className="faq-title"
      >
        {t('frequentlyAskedQuestions')}
      </Typography>
      {faqs.map((item) => (
        <StyledAccordion
          sx={{
            '&.Mui-expanded': { backgroundColor: '#F4F5F7 !important' },
            '&::before': { display: 'none' },
          }}
          key={item.id}
          expanded={expanded === item.id}
          onChange={handleChange(item.id)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: '#1E164ECC' }} />}
            aria-controls={`faq-panel-content-${item.id}`}
            id={`faq-panel-header-${item.id}`}
            sx={{
              margin: '0 !important',
              minHeight: '0 !important',
              padding: '0px !important',
              '&.Mui-expanded': {
                margin: '0 !important',
              },
              '& .MuiAccordionSummary-content': {
                margin: '0 !important',
                alignItems: 'center',
              },
            }}
          >
            <img
              style={{ marginRight: '12px' }}
              src={questionImg}
              alt="question"
            />
            <Typography
              className="faq-question"
              variant="body-16-medium"
              color="#1C1C1E"
            >
              {item?.question?.[language]}
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: '0px !important',
              paddingLeft: '46px !important',
              marginTop: '8px !important',
            }}
          >
            <Typography
              variant="body-14-regular"
              color="#1C1C1EA3"
              className="faq-answer"
              dangerouslySetInnerHTML={{
                __html: item?.answer?.[language]
                  .replace('{{priceStandard}}', priceStandard)
                  .replace('{{priceSpecial}}', priceSpecial),
              }}
            />
          </AccordionDetails>
        </StyledAccordion>
      ))}
    </StyledFAQ>
  );
};
export default FAQ;
